import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, CircularProgress, Card, CardContent } from '@mui/material';
import { CheckCircleOutline, LoginOutlined } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import logo from '../assets/logo.png';

export default function LogoutPage() {
  const navigate = useNavigate();
  const { logout } = useAuth();
  const [done, setDone] = useState(false);

useEffect(() => {
  let cancelled = false;
  const t = setTimeout(async () => {
    await logout();
    if (!cancelled) setDone(true);  // guard against unmount during await
  }, 1500);
  return () => {
    cancelled = true;
    clearTimeout(t);
  };
}, [logout]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0A1628 0%, #1565C0 50%, #0D47A1 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
      }}
    >
      <Card sx={{ maxWidth: 420, width: '100%', textAlign: 'center', borderRadius: 3 }}>
        <CardContent sx={{ p: 5 }}>
          <Box
            component="img"
            src={logo}
            alt="HRMS AI Dashboard logo"
            sx={{
              display: 'block',
              width: 72,
              height: 72,
              borderRadius: '18px',
              mx: 'auto',
              mb: 3,
              objectFit: 'cover',
            }}
          />

          {!done ? (
            <>
              <CircularProgress size={36} sx={{ mb: 2 }} />
              <Typography variant="h6" fontWeight={700} gutterBottom>
                Signing you out…
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Clearing your session securely.
              </Typography>
            </>
          ) : (
            <>
              <CheckCircleOutline sx={{ fontSize: 44, color: 'success.main', mb: 1.5 }} />
              <Typography variant="h6" fontWeight={700} gutterBottom>
                You've been logged out
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                Your session has ended. Thank you for using the HRMS AI Dashboard.
              </Typography>
              <Button
                variant="contained"
                startIcon={<LoginOutlined />}
                onClick={() => navigate('/')}
                fullWidth
                size="large"
              >
                Sign In Again
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
